<div class="mantenimiento-container">

  <img src="assets/logos/pagina_inactivaa.png" 
       alt="Mantenimiento" 
       class="logo-mantenimiento">

</div>